import type { CurrencyAmount } from '@omnipresentgroup/design-system';

export enum SOWStatusEnum {
  SOW_AWAITING_PROPOSAL = 'sow:awaiting-proposal',
  SOW_AWAITING_ACCEPTANCE = 'sow:awaiting-acceptance',
  SOW_ACCEPTED = 'sow:accepted',
}

export enum SeatStatusEnum {
  ARCHIVED = 'archived',
  PENDING = 'pending',
  CONVERTED = 'converted',
}

export enum ArchiveReasonsEnum {
  CHANGE_COUNTRY = 'change country',
  CORRECTION = 'correction',
  DROP_OUT = 'dropout',
  EXPIRED = 'expiration',
}

export type SowStatus = `${SOWStatusEnum}`;
export type SeatStatus = `${SeatStatusEnum}`;
export type ArchiveReason = `${ArchiveReasonsEnum}`;

export type Seat = {
  id: string;
  companyId: string;
  countryName: string;
  desiredStartDate: string;
  sowStatus: SowStatus;
  sowDocUrl?: string;
  createdAt?: string;
  seatStatus: SeatStatus;
  archiveDetails?: {
    archiveReason?: ArchiveReason;
  };
  employeeProfile?: SeatEmployeeProfile;
  billingCurrency?: string;
  firstName?: string;
  lastName?: string;
  annualBaseSalary?: CurrencyAmount;
  isAutomatedUpsellUsed?: boolean;
  sowSignature?: { signedBy: string; time: string; date: string };
  name?: string;
};

// TODO: double check if this is correct
export type SeatEmployeeProfile = {
  // firstName?: string;
  // lastName?: string;
  // pronouns?: string;
  // citizenship?: string;
  // personalEmail?: string;
  // startDate?: string;
  // jobTitle?: string;
  // jobDescription?: string;
  annualBaseSalaryCurrency?: string;
  annualBaseSalaryAmount?: number;
  // managementFeeCurrency?: string;
  // managementFeeAmount?: number;
  // setupFeeCurrency?: string;
  // setupFeeAmount?: number;
  // setupFeeStructure?: setupFeeStructure;
  // depositFee?: DepositFee;
  // additionalCompensation?: string;
  // locationOfWorkType?: string;
  // locationOfWorkAddress?: locationOfWorkAddress;
  // privateAddress?: Address;
  // workEmail?: string;
  // hoursOfWork?: number;
  // probationaryPeriodLength?: number;
  // holidayEntitlementDays?: number;
  // holidayEntitlementType?: string;
  // rightToWorkCheckCompleted?: boolean;
  // employeeType?: EmployeeType;
  // depositType?: DepositType;
  // zeroDepositFee?: number;
  // advancedPaymentDepositPercentage?: number;
  // contractQuestionnaire?: {
  //   templateId?: string;
  //   body: Record<string, AvvokaQuestion>;
  // };
  // employerCosts?: EmployerCostsForSeat;
  // fxFee?: Fee;
};
